import { createSlice } from "@reduxjs/toolkit";
import { DeliveryFeeAPI } from "../../services/delivery-fee";

const DeliveryFee = createSlice({
  name: "deliveryFee",
  initialState: {
    list: [],
    oneDeliveryFee: null,
    total: 0,
  },
  reducers: {
    clearOneDeliveryFee: (state) => {
      state.oneDeliveryFee = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(DeliveryFeeAPI.getAll.fulfilled, (state, action) => {
        const { total, delivery_rates } = action.payload;

        state.list = delivery_rates || [];
        state.total = total || 0;
      })
      .addCase(DeliveryFeeAPI.getOne.fulfilled, (state, action) => {
        state.oneDeliveryFee = action.payload;
      });
  },
});

export const { clearOneDeliveryFee } = DeliveryFee.actions;
export default DeliveryFee;
